import { render, staticRenderFns } from "./ReviewDeadline.vue?vue&type=template&id=5821817c"
import script from "./ReviewDeadline.vue?vue&type=script&lang=js"
export * from "./ReviewDeadline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports